/* LNDA Skin Clinic – felles skript for klinikksidene (layout: klinikk) */
(function () {
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---------- Header, mega-meny og mobilmeny ---------- */
  function initChrome() {
    var hdr = $(".kl .site-header");
    if (hdr) addEventListener("scroll", function () { hdr.classList.toggle("scrolled", scrollY > 10); }, { passive: true });

    var megaBtn = $("#megaBtn"), mega = $("#mega"), megaTimer;
    function setMega(open) { if (!mega) return; mega.classList.toggle("open", open); megaBtn.setAttribute("aria-expanded", open); }
    if (megaBtn && mega) {
      megaBtn.addEventListener("click", function () { setMega(!mega.classList.contains("open")); });
      [megaBtn, mega].forEach(function (el) {
        el.addEventListener("mouseenter", function () { clearTimeout(megaTimer); if (matchMedia("(hover:hover)").matches) setMega(true); });
        el.addEventListener("mouseleave", function () { megaTimer = setTimeout(function () { setMega(false); }, 180); });
      });
      mega.addEventListener("click", function (e) { if (e.target.closest("a")) setMega(false); });
      document.addEventListener("click", function (e) { if (!e.target.closest(".site-header")) setMega(false); });
    }

    var drawer = $("#drawer"), burger = $("#burger"), lastFocus;
    function openDrawer() { lastFocus = document.activeElement; drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); burger.setAttribute("aria-expanded", "true"); document.body.style.overflow = "hidden"; setTimeout(function () { $(".drawer-close", drawer).focus(); }, 50); }
    function closeDrawer(noFocus) { if (!drawer || !drawer.classList.contains("open")) return; drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); burger.setAttribute("aria-expanded", "false"); document.body.style.overflow = ""; if (!noFocus && lastFocus && lastFocus.focus) lastFocus.focus(); }
    if (drawer && burger) {
      burger.addEventListener("click", openDrawer);
      drawer.addEventListener("click", function (e) {
        var b = e.target.closest(".acc-btn");
        if (b) { var p = document.getElementById(b.getAttribute("aria-controls")); var o = b.getAttribute("aria-expanded") === "true"; b.setAttribute("aria-expanded", !o); p.hidden = o; return; }
        var c = e.target.closest("[data-close]"); if (c) closeDrawer(c.tagName === "A");
      });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (mega && mega.classList.contains("open")) { setMega(false); megaBtn.focus(); }
      closeDrawer();
    });
    window.KL = { setMega: setMega, closeDrawer: closeDrawer };
  }

  /* ---------- Hero-video: lyd av/på ---------- */
  function initVideo() {
    var v = $("#heroVideo"), b = $("#soundBtn"); if (!v || !b) return;
    var w = $(".w", b), x = $(".x", b), t = $("span", b);
    b.addEventListener("click", function () {
      var on = v.muted; v.muted = !on;
      if (on) { v.currentTime = 0; v.loop = false; } else { v.loop = true; }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      b.setAttribute("aria-pressed", String(on)); w.style.display = on ? "" : "none"; x.style.display = on ? "none" : ""; t.textContent = on ? b.dataset.off : b.dataset.on;
    });
    v.addEventListener("ended", function () { v.muted = true; v.loop = true; v.play(); b.setAttribute("aria-pressed", "false"); w.style.display = "none"; x.style.display = ""; t.textContent = b.dataset.on; });
    if (reduce) { v.removeAttribute("autoplay"); v.pause(); }
  }

  /* ---------- Finn din behandling (filter) ---------- */
  function initFinder() {
    $$("[data-finder]").forEach(function (root) {
      var chips = $(".chips", root), cards = $$(".card", root), more = $("[data-more]", root), empty = $(".k-empty", root);
      var limit = matchMedia("(max-width:760px)").matches ? 6 : parseInt(root.dataset.limit || "8", 10);
      var current = "alle", expanded = false;
      function render() {
        var list = cards.filter(function (c) { return current === "alle" || (" " + c.dataset.c + " ").indexOf(" " + current + " ") > -1; });
        cards.forEach(function (c) { c.hidden = true; });
        var shown = (current === "alle" && !expanded) ? list.slice(0, limit) : list;
        shown.forEach(function (c) {
          c.hidden = false;
          var tag = $(".tag--dark", c);
          if (tag) tag.textContent = current !== "alle" ? (chips.querySelector('[data-k="' + current + '"]') || {}).textContent || "" : c.dataset.firstLabel || "";
        });
        if (empty) empty.hidden = list.length > 0;
        if (more) { more.hidden = !(current === "alle" && !expanded && list.length > limit); more.textContent = more.dataset.label + " (" + list.length + ")"; }
      }
      function set(k) { current = k; expanded = false; $$(".chip", chips).forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.k === k); }); render(); }
      if (chips) chips.addEventListener("click", function (e) { var b = e.target.closest(".chip"); if (b) set(b.dataset.k); });
      if (more) more.addEventListener("click", function () { expanded = true; render(); });
      document.addEventListener("click", function (e) { var a = e.target.closest("[data-concern]"); if (a && chips.querySelector('[data-k="' + a.dataset.concern + '"]')) { set(a.dataset.concern); try { sessionStorage.removeItem("lnda-concern"); } catch (_) {} } });
      document.addEventListener("click", function (e) { var a = e.target.closest("[data-concern]"); if (a) { try { sessionStorage.setItem("lnda-concern", a.dataset.concern); } catch (_) {} } }, true);
      render();
      try { var k = sessionStorage.getItem("lnda-concern"); if (k) { sessionStorage.removeItem("lnda-concern"); if (chips.querySelector('[data-k="' + k + '"]')) set(k); } } catch (_) {}
    });
  }

  /* ---------- Kontaktskjema på mobil ---------- */
  function initContact() {
    var b = $("#formToggle"), f = $("#contactForm"); if (!b || !f) return;
    if (f.querySelector(".form-ok,.form-err")) f.classList.add("open");
    b.addEventListener("click", function () { var o = f.classList.toggle("open"); b.setAttribute("aria-expanded", String(o)); if (o) { f.scrollIntoView({ behavior: "smooth", block: "start" }); var i = f.querySelector("input"); if (i) i.focus({ preventScroll: true }); } });
  }

  /* ---------- Bestill time / priser ---------- */
  function initBooking() {
    var catsEl = $("#cats"); if (!catsEl) return;
    var chipBar = $("#catbar");
    var norm = function (s) { return String(s).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/å/g, "a").replace(/ø/g, "o").replace(/æ/g, "ae"); };
    function setOpen(c, open) { var b = $(".cat-btn", c), p = $(".cat-panel", c); b.setAttribute("aria-expanded", open); p.hidden = !open; }

    /* Variantvalg */
    catsEl.addEventListener("change", function (e) {
      var inp = e.target.closest(".opt input"); if (!inp) return;
      var row = inp.closest(".trow");
      $(".pwrap", row).innerHTML = inp.dataset.price;
      var note = $(".opt-note", row); if (note) note.textContent = inp.dataset.note || "";
      var bk = $(".book", row); bk.href = inp.dataset.url; bk.setAttribute("aria-label", bk.dataset.base + " – " + inp.dataset.label);
      $(".more", row).href = inp.dataset.url;
    });

    /* Accordion */
    catsEl.addEventListener("click", function (e) { var b = e.target.closest(".cat-btn"); if (!b) return; setOpen(b.closest(".cat"), b.getAttribute("aria-expanded") !== "true"); });
    catsEl.addEventListener("keydown", function (e) {
      if (!e.target.classList.contains("cat-btn")) return;
      var btns = $$(".cat:not([hidden]) .cat-btn", catsEl), i = btns.indexOf(e.target);
      var go = function (j) { e.preventDefault(); btns[(j + btns.length) % btns.length].focus(); };
      if (e.key === "ArrowDown") go(i + 1); else if (e.key === "ArrowUp") go(i - 1); else if (e.key === "Home") go(0); else if (e.key === "End") go(btns.length - 1);
    });

    /* Aktiv chip */
    function markChip(id) {
      if (!chipBar) return;
      $$(".chip", chipBar).forEach(function (ch) {
        var on = ch.dataset.jump === id; ch.setAttribute("aria-current", on ? "true" : "false");
        if (on) { var l = ch.offsetLeft - 20, r = l + ch.offsetWidth + 40; if (l < chipBar.scrollLeft || r > chipBar.scrollLeft + chipBar.clientWidth) chipBar.scrollTo({ left: l, behavior: reduce ? "auto" : "smooth" }); }
      });
    }
    addEventListener("scroll", function () {
      var line = (parseInt(getComputedStyle(document.body).getPropertyValue("--hdr-h")) || 78) + 90, cur = null;
      $$(".cat:not([hidden])", catsEl).forEach(function (c) { if (c.getBoundingClientRect().top <= line) cur = c.dataset.cat; });
      markChip(cur);
    }, { passive: true });

    /* Hopp til kategori / behandling (#injeksjoner, #b-filler) */
    function jump(id, focus) {
      var el = document.getElementById(id); if (!el || !(el.classList.contains("cat") || el.classList.contains("trow"))) return false;
      if (el.closest(".cat").hidden || el.hidden) clearSearch();
      var cat = el.closest(".cat"); setOpen(cat, true);
      var target = el.classList.contains("trow") ? el : cat;
      target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
      if (target.classList.contains("trow")) { target.classList.remove("flash"); void target.offsetWidth; target.classList.add("flash"); }
      if (focus) (target.classList.contains("trow") ? $(".book", target) : $(".cat-btn", cat)).focus({ preventScroll: true });
      markChip(cat.dataset.cat);
      if (location.hash !== "#" + id) history.replaceState(null, "", "#" + id);
      return true;
    }
    document.addEventListener("click", function (e) {
      var a = e.target.closest("a"); if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var href = a.getAttribute("href") || "", id = a.dataset.jump, m = href.match(/^(?:[^#]*bestill-time)?#(.+)$/);
      if (!id && m) id = m[1];
      if (!id) return;
      var el = document.getElementById(id);
      if (!el || !(el.classList.contains("cat") || el.classList.contains("trow"))) return;
      e.preventDefault(); if (window.KL) { KL.setMega(false); KL.closeDrawer(true); } jump(id, true);
    });
    function fromHash() { var id = decodeURIComponent(location.hash.slice(1)); if (id) setTimeout(function () { jump(id, false); }, 60); }
    addEventListener("hashchange", fromHash); fromHash();

    /* Søk */
    var q = $("#q"), qClear = $("#qClear"), qStatus = $("#qStatus"), emptyEl = $("#btEmpty"), saved = null;
    function runSearch() {
      if (!q) return;
      var term = norm(q.value.trim()); qClear.hidden = !q.value;
      var cats = $$(".cat", catsEl);
      if (!term) {
        cats.forEach(function (c) { c.hidden = false; $$(".trow", c).forEach(function (r) { r.hidden = false; }); });
        if (saved) { cats.forEach(function (c) { setOpen(c, saved[c.dataset.cat]); }); saved = null; }
        if (chipBar) $$(".chip", chipBar).forEach(function (ch) { ch.classList.remove("dim"); });
        emptyEl.hidden = true; qStatus.textContent = ""; return;
      }
      if (!saved) { saved = {}; cats.forEach(function (c) { saved[c.dataset.cat] = $(".cat-btn", c).getAttribute("aria-expanded") === "true"; }); }
      var words = term.split(/\s+/), hits = 0, nCats = 0;
      cats.forEach(function (c) {
        var n = 0;
        $$(".trow", c).forEach(function (r) { var s = norm(r.dataset.s || ""); var ok = words.every(function (w) { return s.indexOf(w) > -1; }); r.hidden = !ok; if (ok) n++; });
        c.hidden = n === 0; setOpen(c, n > 0);
        var ch = chipBar && chipBar.querySelector('[data-jump="' + c.dataset.cat + '"]'); if (ch) ch.classList.toggle("dim", n === 0);
        if (n) { hits += n; nCats++; }
      });
      emptyEl.hidden = hits > 0;
      qStatus.textContent = hits ? hits + " treff i " + nCats + " " + (nCats === 1 ? "kategori" : "kategorier") : "Ingen treff";
    }
    function clearSearch() { if (!q) return; q.value = ""; runSearch(); }
    if (q) {
      q.addEventListener("input", runSearch);
      q.addEventListener("keydown", function (e) { if (e.key === "Escape" && q.value) { e.stopPropagation(); clearSearch(); } if (e.key === "Enter") { e.preventDefault(); var f = catsEl.querySelector(".cat:not([hidden]) .trow:not([hidden])"); if (f) f.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" }); } });
      qClear.addEventListener("click", function () { clearSearch(); q.focus(); });
      q.addEventListener("focus", function () { document.body.classList.add("typing"); });
      q.addEventListener("blur", function () { document.body.classList.remove("typing"); });
    }
  }

  function init() { initChrome(); initVideo(); initFinder(); initContact(); initBooking(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", function () { initVideo(); initFinder(); initContact(); });
})();
